import { makeAutoObservable } from "mobx"

import { GetQueryHighlightsResponse } from "@services/search.service"
import SimpleCollectionStore from "@store/utils/SimpleCollectionStore"

import SearchFlowStore from "../search-flow.store"
import QueryAttachmentsStore from "../query-attachments.store"
import { WorkbookSuggestionOption } from "../types"

export class FactFinderSolutionStore {
  constructor() {
    makeAutoObservable(this)
  }

  searchFlowStore = new SearchFlowStore()

  queryAttachments = new QueryAttachmentsStore()

  searchAutocomplete: SimpleCollectionStore<WorkbookSuggestionOption> =
    new SimpleCollectionStore()

  workbookHighlights: SimpleCollectionStore<WorkbookSuggestionOption> =
    new SimpleCollectionStore()

  highlights: GetQueryHighlightsResponse | null = null

  loadingHighlights: boolean = false

  error: string | null = null
}

export default FactFinderSolutionStore
